import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { GlobalMatch } from "./routes";
import DayCycles from "./components/DayCycles";
import Periods from "./components/Periods";
import BellSchedules from "./components/BellSchedules";
import TimetableTemplates from "./components/TimetableTemplates";
import SchoolWiseInformation from "./components/SchoolWiseInformation";
import TimetablePermissions from "./components/TimetablePermissions";
import YardDuties from "./components/YardDuties";
import Spaces from "./components/Spaces";
import AttendanceCategories from "./components/AttendanceCategories";
import AttendanceCodes from "./components/AttendanceCodes";
import SchoolWiseConfiguration from "./components/SchoolWiseConfiguration";
import AttendancePermissions from "./components/AttendancePermissions";
import AttendanceRecording from "AttendanceSettingsV2/components/AttendanceRecording";
import AttendanceCalculation from "AttendanceSettingsV2/components/AttendanceCalculation";
import AttendanceTierSets from "./components/AttendanceTierSets";
import AttendanceTiers from "AttendanceSettingsV2/components/AttendanceTiers";

export default store => ({
  path: "attendance-and-timetable-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import("./components"),
      import("./modules/AttendanceAndTimetableSettingsModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "attendanceAndTimetableSettings",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [
    DayCycles(store),
    Periods(store),
    BellSchedules(store),
    TimetableTemplates(store),
    SchoolWiseInformation(store),
    TimetablePermissions(store),
    Spaces(store),
    YardDuties(store),
    AttendanceCategories(store),
    AttendanceCodes(store),
    SchoolWiseConfiguration(store),
    AttendancePermissions(store),
    AttendanceRecording(store),
    AttendanceCalculation(store),
    AttendanceTierSets(store),
    AttendanceTiers(store),
    GlobalMatch(store), //! this always the last route
  ],
});
